import { WrapperAccordion } from './style';
import { useState } from 'react';

const Accordion = ({ title, children }) => {
  const [isOpen, setOpen] = useState(false);
  return (
    <WrapperAccordion>
      <div className="accordion-wrapper">
        <div
          className={`accordion-title ${isOpen ? 'open' : ''}`}
          onClick={() => setOpen(!isOpen)}
        >
          <div className="accordion-title_stage">
            {title}
          </div>
        </div>
        <div className={`accordion-item ${!isOpen ? 'collapsed' : ''}`}>
          <div className="accordion-content">{children}</div>
        </div>
      </div>
    </WrapperAccordion>
  );
};

export default Accordion;
